module.exports = __webpack_public_path__ + "static/img/1层.20a6050.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/1层.png
// module id = mEHv
// module chunks = 0